if (!customElements.get("search-form")) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[name="q"]');
      // this.overlay = document.querySelector(".site-overlay");
      this.results_product = this.querySelector('[data-results="products"]');
      this.results_product_grid = this.results_product.querySelector(".search-form__grid");
      this.results_article = this.querySelector('[data-results="articles"]');
      this.results_article_grid = this.results_article.querySelector(".search-form__grid");
      this.results_page = this.querySelector('[data-results="pages"]');
      this.results_page_grid = this.results_page?.querySelector(".search-form__grid");

      this.addEventListener("click", event => event.stopPropagation());

      this.querySelector(".search-form__close").addEventListener("click", event => {
        event.stopPropagation();
        this.close();
      });

      window.addEventListener("search::open", () => {
        this.open();
      });

      document.body.addEventListener("click", event => {
        if (event.target.closest("#insta-feed") || event.target.closest(".instafeed-modals-wrapper") || event.target.closest("search-form")) {
          return;
        }

        event.stopPropagation();
        this.close();
      });

      this.input.addEventListener("keypress", () => {
        clearTimeout(this.timeout);
      });

      this.input.addEventListener("input", event => {
        if (this.input.value.length < 2) {
          clearTimeout(this.timeout);
          return;
        }

        this.check_if_done(0);
        this.input.setAttribute("aria-expanded", "false");
        this.querySelectorAll("[data-results-count]").forEach(el => el.setAttribute("data-results-count", 0));
        this.results_product_grid.innerHTML = "";
        this.results_article_grid.innerHTML = "";
        if (this.results_page_grid) this.results_page_grid.innerHTML = "";

        this.timeout = setTimeout(() => {
          this.search();
        }, 500);
      });

      this.scrollbar = new PerfectScrollbar(this, {
        suppressScrollX: true,
        wheelPropagation: false,
        swipeEasing: true,
        minScrollbarLength: 60
      });
    }

    search() {
      const q = this.input.value;
      const root = window.Shopify.routes.root;

      const products = fetch(`${root}search?q=${q}&type=product&view=predictive`)
        .then(response => response.text())
        .then(content => {
          const tmp = document.createElement("div");
          tmp.innerHTML = content;

          if (tmp.querySelector("[data-search-results]")) {
            this.results_product_grid.innerHTML = tmp.querySelector("[data-search-results]").innerHTML;
          }

          let total = 0;
          if (tmp.querySelector("[data-results-count]")) {
            total = parseInt(tmp.querySelector("[data-results-count]").getAttribute("data-results-count"));
          }

          if (total > 0) {
            this.input.setAttribute("aria-expanded", "true");
          }

          this.results_product.querySelectorAll("[data-results-count]").forEach(el => {
            const label = el.querySelector(".search-form__count");
            el.setAttribute("data-results-count", total);

            if (label) {
              label.innerText = `(${total})`;
            }
            if (el.nodeName === "A") {
              el.href = `${root}search?q=${q}&type=product,page,article`;
            }
          });
        });

      const articles = fetch(`${root}search/suggest.json?q=${q}&resources[type]=article&resources[limit]=3&resources[options][fields]=body,title,tag`)
        .then(response => response.json())
        .then(suggestions => {
          this.results_article_grid.innerHTML = "";
          const articles = suggestions.resources.results.articles;

          articles.forEach(article => {
            const el = document.createElement("div");
            el.innerHTML = `<a href="${article.url}" class="search-form__article"><div class="search-form__article-img"><img src="${article.featured_image.url}" alt="${article.featured_image.alt}" loading="lazy"></div><h5>${article.title}</h5></a>`;
            this.results_article_grid.append(el);
          });

          this.results_article.querySelectorAll("[data-results-count]").forEach(el => el.setAttribute("data-results-count", articles.length));
        });

      const pages = !this.results_page_grid ? Promise.resolve() :
        fetch(`${root}search/suggest.json?q=${q}&resources[type]=page&resources[limit]=3&resources[options][fields]=body,title`)
          .then(response => response.json())
          .then(suggestions => {
            this.results_page_grid.innerHTML = "";
            const pages = suggestions.resources.results.pages;

            pages.forEach(page => {
              const el = document.createElement("div");
              el.innerHTML = `<a href="${page.url}" class="search-form__article"><h5>${page.title}</h5></a>`;
              this.results_page_grid.append(el);
            });

            if (pages.length > 0) {
              this.input.setAttribute("aria-expanded", "true");
            }

            this.results_page.querySelectorAll("[data-results-count]").forEach(el => el.setAttribute("data-results-count", pages.length));
          });

      Promise.allSettled([products, articles, pages]).then(() => this.check_if_done(true));
    }

    check_if_done(done) {
      if (done) {
        this.classList.remove("search-form--loading");

        setTimeout(() => {
          this.scrollTop = 1;
          this.scrollTop = 0;
        }, 50);
      } else {
        this.classList.add("search-form--loading");
      }
    }

    open() {
      this.style.display = "block";
      // this.overlay.style.opacity = "1";
      this.input.focus();

      setTimeout(() => {
        this.style.opacity = "1";
      });
    }

    close() {
      this.style.opacity = "0";
      // this.overlay.style.opacity = "0";

      setTimeout(() => {
        this.style.display = "none";
      }, 150);
    }
  }

  customElements.define("search-form", SearchForm);
}